import React, { Component } from 'react';
import './App.css';

import { Switch, Route } from 'react-router-dom'


import Feed from './containers/Feed/Feed'
import Featured from './containers/Featured/Featured'

class App extends Component {
   constructor(props) {
      super(props);
   }

	render = () => {
      return (
         <Switch>
           <Route path='*/news' component={Feed} />
           <Route path='/' component={Featured} />
         </Switch>
      );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js